import React from 'react';
import loadable from '@loadable/component';
// import pMinDelay from 'p-min-delay';
import Skeleton from '../skeleton';

const Loadable = ({ loader, delay = 0 }) =>
  loadable(() => (delay ? loader() : loader()), {
    fallback: <Skeleton active />,
  });

export default Loadable;
